<template>
  <div class="recipeBatchPrint_warp">
    <div class="search_warp">
      <el-form ref="form" :model="searchForm" inline>
        <el-form-item label="支付类型">
          <el-select v-model="searchForm.isYbPay">
            <el-option label="医保" :value="1"></el-option>
            <el-option label="非医保" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker v-model="searchForm.date" type="date" placeholder="选择日期" format="yyyy-MM-dd"
            :clearable="false" :editable="false" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="处方类型">
          <el-select v-model="searchForm.recipeType">
            <el-option v-for="item in recipeTypeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="打印状态">
          <el-select v-model="searchForm.printCount">
            <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="医生">
          <el-select v-model="searchForm.doctorId" multiple filterable remote reserve-keyword placeholder="请输入关键词"
            :remote-method="getDoctorOption" collapse-tags>
            <el-option v-for="item in doctorOption" :key="item.doctorId" :value="item.doctorId"
              :label="item.doctorName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <custom-button type="primary" @click="handleSearch">查询</custom-button>
          <custom-button type="" @click="handleReset">重置</custom-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="action_warp">
      <custom-button type="primary" plain @click="batchPrint" :disabled="isPrinting"> {{ isPrinting ? '打印中' :
        '批量打印' }}</custom-button>
      <div class="action_warp_tips" v-if="multipleSelection.length > 0">共{{ multipleSelection.length }}张，请检查打印纸张</div>
      <div class="action_warp_print">
        <div class="action_warp_print_tips" v-if="isPrinting">当前存在打印任务，请等待!</div>
      </div>
    </div>
    <div class="table_warp">
      <customTable max-height="600" :showPages="false" :cell-style="{ borderColor: '#DDDDDD' }" tooltip-effect="dark"
        @selection-change="handleSelectionChange" :tableData="tableData" :column="column"
        :header-cell-style="{ background: '#F0F1F3', borderColor: '#DDDDDD' }" border>
        <template slot="printCount" slot-scope="scope">
          <div>
            <span>{{ scope.row.printCount > 0 ? '已打印' : '未打印' }}</span>
            <span :style="{ color: scope.row.printCount > 0 ? 'coral' : 'transparent' }">（{{ scope.row.printCount
            }}）</span>
          </div>
        </template>
      </customTable>
    </div>
    <el-dialog title="打印结果" :visible.sync="dialogVisible" width="60%" @close="dialogClose">
      <div class="dialog_tips" v-if="remainNum > 0">打印中，还剩{{ remainNum }}张</div>
      <customTable :showPages="false" max-height="400" :cell-style="{ borderColor: '#DDDDDD' }" tooltip-effect="dark"
        :tableData="dialogData" :column="dialogColumn"
        :header-cell-style="{ background: '#F0F1F3', borderColor: '#DDDDDD' }" border>
        <template slot="result" slot-scope="scope">
          <div v-if="['', null, undefined].includes(scope.row.result)">等待中</div>
          <div v-else-if="scope.row.result == '1'">打印成功</div>
          <div v-else style="color:coral">
            <div>打印失败，请联系管理员处理</div>
            <div>（原因：{{ scope.row.resultMsg }}）</div>
          </div>
        </template>
      </customTable>
    </el-dialog>
  </div>

</template>

<script>
import customTable from '@/components/customTable/customTable'
import { queryRecipeBatchPrint, queryQueue } from '@/api/recipePrint'
import { batchPrint, consumeMessage, checkDevice } from '@/api/print'
import { isNull, debounce, isEmptyArray, deepClone, msgboxWarning,dictText } from '@/utils/validateBase'
import { doctorDTO } from '@/DTO/index'
import moment from 'moment'
export default {
  components: { customTable },
  data() {
    return {
      searchForm: {
        date: this.$moment().subtract(1, 'days').format('YYYY-MM-DD'),
        printCount: '',
        recipeType:null,
        doctorId: [],
        deptId: this.$session.get('deptId'),
        isYbPay:1
      },
      deptList: [],
      statusList: [
        { label: '全部', value: '' },
        { label: '未打印', value: '0' },
        { label: '已打印', value: '1' },
      ],
      recipeTypeList: [
        { label: '全部', value: null},
				{ label: '中药处方', value: '1' },
        { label: '理疗处方', value: '3' },
        { label: '中成药处方', value: '4' },
			],
      tableData: [],
      column: [
        { type: "selection", width: '52' },
        { label: '打印次数', slotName: 'printCount' },
        {
          label: "处方日期", prop: "payTime", formatter(row) {
            return moment(row.payTime).format('YYYY-MM-DD')
          }
        },
        { label: "处方开具医生", prop: "doctorName", },
        { label: "处方类型", prop: "recipeName",formatter(row){
          const recipeTypeList = [
             { label: '全部', value: null},
				     { label: '中药处方', value: '1' },
             { label: '理疗处方', value: '3' },
             { label: '中成药处方', value: '4' },
          ]
          return row.recipeType == '1' && row.isYlcp == '1' ? '医联处方' : dictText(row.recipeType,recipeTypeList)
        }},
        { label: "患者名称", prop: "patientName", },
        { label: "患者性别", prop: "sexLabel", },
        { label: "患者年龄", prop: "age", },
      ],
      dialogColumn: [
        { label: '处方日期', prop: 'recipeCreateTime',formatter(row) {
            return moment(row.recipeCreateTime).format('YYYY-MM-DD')
          } },
        { label: '处方开具医生', prop: 'doctorName' },
        { label: '患者名称', prop: 'patientName' },
        { label: '患者性别', prop: 'sexLabel' },
        { label: '患者年龄', prop: 'age' },
        { label: '打印结果', slotName: 'result', width: 300 },
      ],
      dialogVisible: false,
      doctorOption: [],
      uuid: 'Statement-recipeBatchPrint',
      multipleSelection: [],
      dialogData: [],
      isPrinting: false,
      //剩余数量
      remainNum: 0,//剩余数量
    }
  },
  created() {
    if([0,-1].includes(this.searchForm.deptId)) return
    this.queryRecipeBatchPrint()
    this.queryQueue()
  },
  methods: {
    handleSearch() {
      this.queryRecipeBatchPrint()
    },
    handleReset() {
      this.searchForm = {
        date: this.$moment().subtract(1, 'days').format('YYYY-MM-DD'),
        printCount: '',
        doctorId: [],
        deptId: this.$session.get('deptId'),
        recipeType:null,
        isYbPay:1
      }
      this.queryRecipeBatchPrint()
    },
    async batchPrint() {
      let multipleSelection = this.multipleSelection
      if (isEmptyArray(multipleSelection)) {
        this.$message.error('请选择需要打印的处方')
        return
      }
      // 检查打印设备
      let device = await this.checkDevice()
      // 开始打印
      let queueId = await this.handlePrint(device)
      //查询打印结果
      await this.getConsumeMessage(queueId)
    },
    //执行打印
    handlePrint(device) {
      return new Promise(async (resolve, reject) => {
        if (isNull(device)) {
          resolve(null)
          // this.$message.error('请配置默认打印或检查打印设备')
          return
        } else {
          // 二次确认
          msgboxWarning(this, {
            message: `请检查打印机，确保纸张大于${this.multipleSelection.length}张`,
            confirmFn: async () => {
              let printList = []
              this.multipleSelection.forEach(v => {
                printList.push({ id: v.orderCaseProjectRecipeId, printType: '2', orderType: v.recipeType == '3' ? '2' : '1' })
              })
              let params = {
                deptId: this.$session.get('deptId'),
                paramCode: this.uuid,
                printList,
                delay: 2000,
                isCount:1
              }
              let { code, data } = await batchPrint(params)
              if (code == 200) {
                this.isPrinting = true
                this.dialogData = deepClone(this.multipleSelection)
                this.dialogVisible = true
                resolve(data)
              } else {
                this.isPrinting = false
                resolve(null)
              }
            },
            cancelFn: () => {
            },
          });
        }
      })
    },
    async queryRecipeBatchPrint() {
      let params = { ...this.searchForm }
      let { code, data } = await queryRecipeBatchPrint(params)
      if (code == 200) {
        this.tableData = data
      }
    },
    getDoctorOption: debounce(async function (val) {
      if (isNull(val)) return;
      this.doctorOption = []
      let { code, rows } = await doctorDTO.getDoctorList({ doctorName: val, pageNum: 1, pageSize: 100, status: '0' })
      if (code == 200) {
        this.doctorOption = rows
      }
    }, 500),
    //检查是否存在打印任
    async queryQueue() {
      let { code, data } = await queryQueue({ param_1: this.$session.get('deptId'), param_2: this.uuid })
      if (code == 200) {
        this.isPrinting = isNull(data) ? false : true
        if(!isNull(data)){
          this.timeoutId2 = setTimeout(() => {
            this.queryQueue()
          }, 2*1000);
        }else{
          clearTimeout(this.timeoutId2)
        }
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    //检查配置的设备是否在线,同时检查有没有配置
    checkDevice() {
      // 目前此地方只打印处方
      return new Promise(async (resolve, reject) => {
        let { code, data } = await checkDevice({ printType: '2' })
        if (code == 200) {
          resolve(data)
        } else {
          resolve(null)
        }
      })
    },
    //查询打印进度
    async getConsumeMessage(id) {
      if (isNull(id)) return;
      let { code, data } = await consumeMessage({ id })
      if (code == 200) {
        let list = deepClone(this.dialogData)
        // if (isNull(data) || isEmptyArray(data)){
        //   list.forEach(v=>{
        //     v.result = 1
        //   })
        //   this.remainNum = 0
        //   this.$set(this, 'dialogData', list)
        //    return;
        // }
        list.forEach(v1 => {
          data.forEach(v2 => {
            if (v1.orderCaseProjectRecipeId == v2.dataId) {
              v1.result = v2.code
              v1.resultMsg = v2.msg
            }
          })
        })
       if(!isEmptyArray(data)){
         let lastObj = data[data.length - 1]
          if (lastObj.type == 1) {
            this.remainNum = lastObj.total - lastObj.completeNum
          }
       }
        let endIndex = data.findIndex(v => { return v.type == -1 })
        if (endIndex > -1) {
          this.isPrinting = false
          this.$message.success('全部打印完成')
          clearTimeout(this.timeoutId)
          return;
        }
        this.$set(this, 'dialogData', list)
        this.$forceUpdate()
        this.timeoutId = setTimeout(() => {
          this.getConsumeMessage(id)
        }, 1 * 1000);
      }
    },
    dialogClose() {
      this.multipleSelection = []
      this.queryRecipeBatchPrint()
      if(this.isPrinting){
        this.queryQueue()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.recipeBatchPrint_warp {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 16px;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .search_warp {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .action_warp {
    display: flex;
    align-items: flex-end;

    .action_warp_tips {
      font-size: 13px;
      color: coral;
      margin-bottom: 2px;
      margin-left: 8px;
    }
    .action_warp_print{
      height:100%;
      flex:1;
      display:flex;
      align-items: center;
      justify-content:  center;
    }
    .action_warp_print_tips{
      width:300px;
      font-size:20px;
      text-align:center;
      padding:4px 0;
      border-radius:4px;
      background: #FFF0E1;
      color: #FE8F1F;
    }
  }

  .table_warp {
    margin-top: 16px;
    flex: 1;
    overflow: auto;
  }
}

.dialog_tips {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}
</style>